import {
  all,
  call,
  put,
  select,
  takeEvery,
} from 'redux-saga/effects';

import {
  listingApi,
} from '../../api';
import {
  errorHandler, successHandler,
} from '../../libs/ga';
import {
  cloneDeep,
  forEach,
} from '../../libs/lodash';

import {
  CABINET,
} from './constants';

function* storeCabinet(data = {}, merge = true) {
  yield put({
    type: CABINET.update,
    data,
    merge,
  });
}

function* fetchCabinet({
  data,
}) {
  yield* storeCabinet(data);
}

function* updateCabinet({
  data, onSuccess,
}) {
  try {
    const {
      _id,
      ...rest
    } = data;
    let id = _id;
    if (_id) {
      yield call(() => new Promise((resolve, reject) => {
        listingApi.update({
          collection: 'cabinet',
          payload: {
            _id,
            data: rest,
          },
        }).then(() => resolve(true))
          .catch((error) => reject(error));
      }));
      yield* storeCabinet({
        [data._id]: data,
      });
    } else {
      const {
        newData,
      } = yield call(() => new Promise((resolve, reject) => {
        listingApi.create({
          collection: 'cabinet',
          payload: {
            data,
          },
        }).then((res) => resolve(res.data))
          .catch((err) => reject(err));
      }));
      id = newData._id;
      yield* storeCabinet({
        [newData._id]: newData,
      });
    }
    successHandler('Thành công', 'Cập nhật thành công', onSuccess(id));
  } catch (error) {
    yield* storeCabinet();
    errorHandler('Thất bại', error);
  }
}

function* removeCabinet({
  _id,
}) {
  const {
    cabinet,
  } = yield select();
  try {
    yield call(() => new Promise((resolve, reject) => {
      listingApi.remove({
        collection: 'cabinet',
        payload: {
          _id,
        },
      }).then(() => resolve(true))
        .catch((error) => reject(error));
    }));

    const newData = cloneDeep(cabinet.data);
    delete newData[_id];
    yield* storeCabinet(newData, false);

    successHandler('Thành công', 'Xóa thành công');
  } catch (error) {
    yield* storeCabinet();
    errorHandler('Thất bại', error);
  }
}

function* importCabinet({
  data = [],
}) {
  yield call(() => new Promise((resolve, reject) => {
    listingApi.importData({
      collection: 'cabinet',
      payload: {
        data,
      },
    }).then(() => resolve(true))
      .catch((err) => reject(err));
  }));
  const {
    cabinet,
  } = yield select();
  const newData = cloneDeep(cabinet.data);
  forEach(
    (obj) => {
      newData[obj._id] = obj;
    },
    data,
  );
  yield* storeCabinet(newData);
  successHandler('Thành công', 'Cập nhật thành công');
}

export default function* cabinetSaga() {
  yield all([
    yield takeEvery(CABINET.handlers.fetch, fetchCabinet),
    yield takeEvery(CABINET.handlers.import, importCabinet),
    yield takeEvery(CABINET.handlers.update, updateCabinet),
    yield takeEvery(CABINET.handlers.remove, removeCabinet),
  ]);
}
